import { cn } from "@/lib/utils";
import { Star } from "lucide-react";

interface StarRatingProps {
  value: number; // e.g., 4.73
  total?: number; // default is 5
  starSize?: number;
  starColor?: string;
  className?: string;
}
export const StarRating = (props: StarRatingProps) => {
  const {
    value,
    total = 5,
    starSize = 15,
    starColor = "text-yellow-700",
    className
  } = props;

  const rounded = Math.round(value * 2) / 2; // Round to nearest .5

  const stars = Array.from({ length: total }, (_, i) => {
    const index = i + 1;
    if (rounded >= index) return "full";
    if (rounded + 0.5 === index) return "half";
    return "empty";
  });

  return (
    <div className={cn(`flex items-center text-yellow-500 ${starColor}`, className)}>
      {stars.map((type, i) => {
        const starKey = `star-${i + 1}`;
        return (
          <div key={starKey} className="relative h-5 w-5">
            {/* Outline star always visible */}
            <Star className="stroke-current" size={starSize} />

            {/* Full star overlay */}
            {type === "full" && (
              <Star
                className={`absolute top-0 left-0 fill-current text-yellow-500 ${starColor}`}
                size={starSize}
              />
            )}

            {/* Half star overlay */}
            {type === "half" && (
              <Star
                className={`absolute top-0 left-0 overflow-hidden fill-current text-yellow-500 ${starColor}`}
                size={starSize}
                style={{ clipPath: "inset(0 50% 0 0)" }} // shows only left half
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
